import {COND, OP, LEFT, RIGHT, AND, EQ, SEPARATOR} from "./RuleObjectTypes";
import flatten from "lodash/flatten";

export const RuleReducer = (state, action) => {
    switch (action.type) {
        case "ADD_CONDITIONAL":
            let tempArr =[...state.rule]
            if (state.rule.length === 0) {
                tempArr.push({
                    type: COND,
                    subConditionOp: EQ,
                    leftFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                    rightFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                });
            } else {
                tempArr.push({type: OP, subConditionOp: AND});
                tempArr.push({
                    type: COND,
                    subConditionOp: EQ,
                    leftFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                    rightFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                });
            }
            let finalrule = applyPositions(tempArr);

            return {rule: [...finalrule]};
        case "DELETE_CONDITION":
            let deleteArr = [...state.rule]
            deleteArr = deleteCondition(state.rule, action.position);
            deleteArr = cleanupState(deleteArr);
            deleteArr = removeAdjacentOperators(deleteArr);
            deleteArr = removeOrphanOperators(deleteArr);
            deleteArr = applyPositions(deleteArr);
            return {rule: [...deleteArr]};
        case "ADD_NESTED_CONDITION":
            //This will be added to non-nested rule conditions and make it a nested rule condition in state\
            let nestedRule = state.rule;
            let toAdd = [
                nestedRule[action.position],
                {type: OP, subConditionOp: AND},
                {
                    type: COND,
                    subConditionOp: EQ,
                    leftFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                    rightFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                },
            ];
            nestedRule.splice(action.position, 1, toAdd);
            nestedRule = applyPositions(nestedRule);
            return {rule: [...nestedRule]};
        case "ADD_SUBCONDITION":
            let subConditionRule = state.rule;
            subConditionRule[action.position].push({type: OP, subConditionOp: AND});
            subConditionRule[action.position].push({
                type: COND,
                subConditionOp: EQ,
                leftFilters: [{type: COND, attrID: 0, AttrValueId: 0}],
                rightFilters: [{type: COND, attrID: 0, AttrValueId: 0}],
            });
            subConditionRule = applyPositions(subConditionRule);
            return {rule: [...subConditionRule]};
        case "ADD_NESTCONDITION":
            let nestConditionRule = state.rule;
            let toAdds = [
                nestConditionRule[action.position],
                {type: OP, subConditionOp: AND},
                {
                    type: COND,
                    subConditionOp: EQ,
                    leftFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                    rightFilters: [
                        {
                            type: COND,
                            attrID: 0,
                            AttrValueId: 0,
                        },
                    ],
                },
            ];
            nestConditionRule.splice(action.position, 1, toAdds);
            nestedRule = applyPositions(nestConditionRule);
            return {rule: [...nestedRule]};
        case "LEFT_INDENT":
            let leftIndentArr = [...state.rule]
            leftIndentArr = leftIndent(state.rule, action.position);
            leftIndentArr = cleanupState(leftIndentArr);
            leftIndentArr = removeAdjacentOperators(leftIndentArr);
            leftIndentArr = removeOrphanOperators(leftIndentArr);
            leftIndentArr = applyPositions(leftIndentArr);
            return {rule: [...leftIndentArr]};
        case "RIGHT_INDENT":
            let rightIndentArr = [...state.rule];
            rightIndentArr = rightIndent(state.rule, action.position);
            rightIndentArr = cleanupState(rightIndentArr);
            rightIndentArr = removeAdjacentOperators(rightIndentArr);
            rightIndentArr = removeOrphanOperators(rightIndentArr);
            rightIndentArr = applyPositions(rightIndentArr);
            return {rule: [...rightIndentArr]}
        case "SET_LEFT_ATTR":
            let leftAttRule = state.rule;
            leftAttRule = setLeftAttr(leftAttRule, action);
            return { rule:leftAttRule };
        case "SET_RIGHT_ATTR":
            let rightAttRule = state.rule;
            rightAttRule = setRightAttr(rightAttRule, action);
            return { rule:rightAttRule };
        case "SET_COND_OP":
            let condOPrule = state.rule;
            condOPrule = setSubConditionOp(condOPrule, action);
            return { rule:condOPrule };
        case "APPLY_FILTERS":
           let applyFiltersArr = state.rule;
            applyFiltersArr = applyFilters(applyFiltersArr, action);
            return { rule:applyFiltersArr };
        case "CBM_RULE_TYPE":
            let CBMRuleType = state.rule;
            CBMRuleType = setCbmRule(CBMRuleType, action);
            return { rule:CBMRuleType };
        case "UPDATE_RULE":
            let updateRuleArr = [...state.rule];
            updateRuleArr = setUpdateRule(updateRuleArr, action);
            return {rule: [...updateRuleArr]};
        default:
            throw new Error();
    }
}

function setUpdateRule(rule, action) {
    return action.updatedRule;
}

function applyPositions(ruleArray, positionPrefix = "") {
    let position = "";
    let pIndex = "";
    ruleArray.forEach((element, index) => {
        if (Array.isArray(element)) {
            pIndex = positionPrefix
                ? `${positionPrefix}${SEPARATOR}${index}`
                : index.toString();
            applyPositions(element, `${pIndex}`);
        } else {
            position = positionPrefix
                ? `${positionPrefix}${SEPARATOR}${index}`
                : index.toString();
            element.position = position;
        }
    });
    return ruleArray;
}

function deleteCondition(ruleArray, position) {
    let posArray = position.split(SEPARATOR); //we get something like ['1','1','10']
    if (posArray.length === 1) {
        let elPos = parseInt(posArray[0]);
        //remove suceeding operator if it is the first conditional
        if (elPos === 0) ruleArray.splice(elPos, 2);
        //preceding operator if its not the first condition
        else ruleArray.splice(elPos - 1, 2);
    } else if (posArray.length > 1) {
        let startAt = parseInt(posArray.slice(-1)[0]);

        let evalString = "ruleArray";
        posArray.slice(0, -1).forEach((el) => (evalString += `[${el}]`));
        let refToRemove = eval(evalString);

        if (startAt === 0) {
            refToRemove.splice(startAt, 2);
        } else refToRemove.splice(startAt - 1, 2);
    }
    return ruleArray;
}

function cleanupState(state) {
    //this function will remove empty arrays and ensure that no two conditions are adjacent
    state.forEach((element, index) => {
        if (Array.isArray(element)) {
            if (element.length === 0) {
                state.splice(index, 1);
            } else cleanupState(element);
        }
    });
    state = removeEmptyNestedArrays(state);
    return state;
}

function removeAdjacentOperators(state) {
    let prev = state[0];
    for (let i = 1; i < state.length; i++) {
        if (state[i].type && prev.type && state[i].type === prev.type) {
            state.splice(i, 1);
        } else if (Array.isArray(state[i])) {
            state[i] = removeAdjacentOperators(state[i]);
        }
        prev = state[i];
    }
    return state;
}

function removeOrphanOperators(state) {
    //removes operators on the edge of arrays in some edge cases
    state.forEach((element, index) => {
        if (Array.isArray(element)) {
            removeOrphanOperators(element);
        } else {
            //
            if (
                element.type &&
                element.type === OP &&
                (index === 0 || index === state.length - 1)
            )
                state.splice(index, 1);
        }
    });
    return state;
}

function leftIndent(state, position) {
    let posArray = position.split(SEPARATOR);
    if (posArray.length > 1) {
        let localPos = parseInt(posArray.slice(-1));

        //get reference from where to remove conditions from state array
        let refToEval = "state";
        posArray.slice(0, -1).forEach((el) => (refToEval += `[${el}]`));
        let refToRemove = eval(refToEval);

        //get reference from where to add conditions in state array
        let evalString = "state";
        posArray.slice(0, -2).forEach((el) => (evalString += `[${el}]`));
        let refToAdd = eval(evalString);

        //check where the element is in the array
        if (localPos === 0) {
            //element is in the beginning
            let startAt = localPos;
            let itemsToRemove = 2;
            let toInsertAt = parseInt(posArray.slice(-2, -1));
            let conditions = refToRemove.splice(startAt, itemsToRemove);
            refToAdd.splice(toInsertAt, 0, ...conditions);
        } else if (localPos === refToRemove.length - 1) {
            //element is in the end
            let startAt = localPos - 1;
            let itemsToRemove = 2;
            let toInsertAt = parseInt(posArray.slice(-2, -1)) + 1;
            let conditions = refToRemove.splice(startAt, itemsToRemove);

            refToAdd.splice(toInsertAt, 0, ...conditions);
        } else {
            //element is in the middle
            /* We think of array to break in three parts
                1st part will be untouched
                the middle part is the one we need to left indent
                bottom part is the one we need to split of before we left indent middle part
            */
            //break off bottom part and insert below
            let startAt = localPos + 2;
            let itemsToRemove = refToRemove.length - localPos;
            let toInsertAt = parseInt(posArray.slice(-2, -1)) + 1;
            let conditions = refToRemove.splice(startAt, itemsToRemove);
            refToAdd.splice(toInsertAt, 0, conditions);

            //break the actual condition to move:
            startAt = localPos - 1;
            itemsToRemove = 3; //since this is middle,we break pre and post operators
            toInsertAt = parseInt(posArray.slice(-2, -1)) + 1;
            conditions = refToRemove.splice(startAt, itemsToRemove);
            refToAdd.splice(toInsertAt, 0, ...conditions);
        }
    }
    return state;
}

function rightIndent(state, position) {
    //for every condition, check if adjacent conditions above or below are already in an array,
    //if so, join them with operator
    let posArray = position.split(SEPARATOR);
    let localPos = parseInt(posArray.slice(-1));
    let refToEval = "state";
    posArray.slice(0, -1).forEach((el) => (refToEval += `[${el}]`));
    let refToRemove = eval(refToEval);
    if (localPos === 0) {
        //check if there is adjacent array below, it would be two places down
        if (Array.isArray(refToRemove[localPos + 2])) {
            let conditions = refToRemove.splice(0, 2);
            refToRemove[0].splice(0, 0, ...conditions);
        } else {
            let conditions = refToRemove.splice(0, 1);
            refToRemove.splice(0, 0, conditions);
        }
    } else if (localPos === refToRemove.length - 1) {
        if (Array.isArray(refToRemove[localPos - 2])) {
            let conditions = refToRemove.splice(localPos - 1, 2);
            refToRemove[localPos - 2].push(...conditions);
        } else {
            let conditions = refToRemove.splice(localPos, 1);
            refToRemove.splice(localPos, 0, conditions);
        }
    } else {
        let preceedingConditionInArray = !!Array.isArray(refToRemove[localPos - 2]);
        let succeedingConditionInArray = !!Array.isArray(
            refToRemove[localPos + 2]
        );
        if (preceedingConditionInArray && succeedingConditionInArray) {
            let conditions = refToRemove.splice(localPos - 2, 5);
            conditions = flatten(conditions);
            refToRemove.splice(localPos - 2, 0, conditions);
        } else if (preceedingConditionInArray && !succeedingConditionInArray) {
            let conditions = refToRemove.splice(localPos - 2, 3);
            conditions = flatten(conditions);
            refToRemove.splice(localPos - 2, 0, conditions);
        } else if (!preceedingConditionInArray && succeedingConditionInArray) {
            let conditions = refToRemove.splice(localPos, 3);
            conditions = flatten(conditions);
            refToRemove.splice(localPos, 0, conditions);
        } else {
            let conditions = refToRemove.splice(localPos, 1);
            refToRemove.splice(localPos, 0, conditions);
        }
    }
    return state;
}

function removeEmptyNestedArrays(ar) {
    let isEmpty = false;
    ar.forEach((element, index) => {
        if (Array.isArray(element)) {
            isEmpty = detectEmptyNestedArray(element);
            if (isEmpty) ar.splice(index, 1);
        }
    });
    return ar;
}

function detectEmptyNestedArray(element) {
    let isEmpty = false;
    if (Array.isArray(element) && element.length === 1) {
        isEmpty = detectEmptyNestedArray(element[0]);
    } else if (Array.isArray(element) && element.length === 0) isEmpty = true;

    return isEmpty;
}

function setLeftAttr(rule, action) {
    let refToEval = "rule";
    let startAt = getStartAt(action.position);
    let posArray = action.position.split(SEPARATOR);
    posArray.slice(0, -1).forEach((el) => (refToEval += `[${el}]`));
    let refToUpdate = eval(refToEval);
    let {leftAttrID, position, ...rest} = refToUpdate[startAt];
    refToUpdate.splice(startAt, 1, {
        position: action.position,
        leftAttrID: action.leftAttrID,
        ...rest,
    });
    return rule;
}


function setRightAttr(rule, action) {
    let refToEval = "rule";
    let startAt = getStartAt(action.position);
    let posArray = action.position.split(SEPARATOR);
    posArray.slice(0, -1).forEach((el) => (refToEval += `[${el}]`));
    let refToUpdate = eval(refToEval);
    let {rightAttrID, position, ...rest} = refToUpdate[startAt];
    refToUpdate.splice(startAt, 1, {
        rightAttrID: action.rightAttrID,
        position: action.position,
        ...rest,
    });
    return rule;
}

function setSubConditionOp(rule, action) {
    let refToEval = "rule";
    let startAt = getStartAt(action.position);
    let posArray = action.position.split(SEPARATOR);
    posArray.slice(0, -1).forEach((el) => (refToEval += `[${el}]`));
    let refToUpdate = eval(refToEval);
    let {subConditionOp, position, ...rest} = refToUpdate[startAt];
    refToUpdate.splice(startAt, 1, {
        subConditionOp: action.subConditionOp,
        position: action.position,
        ...rest,
    });
    return rule;
}

function applyFilters(rule, action) {
    let refToEval = "rule";
    let startAt = getStartAt(action.position);
    let posArray = action.position.split(SEPARATOR);
    posArray.slice(0, -1).forEach((el) => (refToEval += `[${el}]`));
    let refToUpdate = eval(refToEval);

    if (action.side === LEFT) {
        let {leftFilters, position, ...rest} = refToUpdate[startAt];
        refToUpdate.splice(startAt, 1, {
            position: action.position,
            leftFilters: action.filtersArray,
            ...rest,
        });
        return rule;
    } else if (action.side === RIGHT) {
        let {rightFilters, position, ...rest} = refToUpdate[startAt];
        refToUpdate.splice(startAt, 1, {
            position: action.position,
            rightFilters: action.filtersArray,
            ...rest,
        });
        return rule;
    }
}

function setCbmRule(rule, action) {
    let updatedRule = [...action.data];
    // let ruleArr = action.data;
    // for (let i = 0; i < ruleArr.length; i++) {
    //     if(ruleArr[i].compatibility !== 'incompatible'){
    //         updatedRule.push({
    //             leftProdId: ruleArr[i].leftProdId,
    //             rightProdId: ruleArr[i].right,
    //             compatibility: ruleArr[i].compatibility,
    //             level:ruleArr[i].level,
    //         });
    //     }
    // }
    rule = updatedRule;
    return rule;
}

function getStartAt(position) {
    //position should always be a string
    let startAt = position;
    let res = position.search(/-[0-9]*$/i);
    if (res > -1) {
        startAt = position.slice(res + 1);
    }
    return startAt;

}